// extracted by mini-css-extract-plugin
export default {"filterRow":"AuditLog-module__filterRow--AGiMk","dataTable":"AuditLog-module__dataTable--B_aBh","results":"AuditLog-module__results--zCVNF","noData":"AuditLog-module__noData--d0mKn"};